import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('powerstreamcooperation');

    return (
        <div className={`powerstream-cooperation-A ${css['powerstream-cooperation-A']}`}>
            <EFPicture
                src="/responsive/picture/powerstream-cooperation/1_1366.jpg"
                srcPad="/responsive/picture/powerstream-cooperation/1_768.jpg"
                srcMobile="/responsive/picture/powerstream-cooperation/1_375.jpg"
                alt={t('secA_title')}
            />
            <div className="text-wrapper">
                <p className="title">{t('secA_title')}</p>
                <p className="desc">{t('secA_desc')}</p>
                <a
                    className="banner-btns"
                    href="#powerstream-cooperation-G"
                    onClick={() =>
                        gtm.push({
                            event: 'uaEvent',
                            event_name: 'select_banner',
                            banner_name: t('secA_title'),
                            position: 'banner_1',
                            button_name: t('secA_btn'),
                        })
                    }
                >
                    {t('secA_btn')}
                </a>
            </div>
        </div>
    );
}
